import React from "react";
import { getGradientForId } from "../../utils/gradients";

/**
 * Renders the user's uploaded photo if present, otherwise auto-generates
 * a branded workout-summary card (gradient + title + muscle groups) —
 * photo upload isn't wired to real storage in this pass, so every mock
 * post falls back to the generated card.
 */
const PostImage = ({ postId, imageUrl, workoutTitle, muscleGroups }) => {
  if (imageUrl) {
    return (
      <div className="wpc-image">
        <img src={imageUrl} alt={`${workoutTitle} workout`} loading="lazy" />
      </div>
    );
  }

  const gradient = getGradientForId(postId);
  return (
    <div
      className="wpc-image wpc-image--generated"
      style={{ background: gradient.bg, color: gradient.text }}
    >
      <p className="wpc-image-title">{workoutTitle}</p>
      <p className="wpc-image-sub">{muscleGroups.join(" + ")}</p>
    </div>
  );
};

export default PostImage;
